module.exports = __webpack_public_path__ + "static/media/upload_more.026c5639.svg";